import Vue from 'vue'
import store from './../../store'
import notificationTransformer from '../../transformers/notification'
const success = (noti) => {
  store.dispatch('alerts/reciveAlerts', noti)
}

export default () => {
  Vue.$http.get('catalogs/common/notifications/')
  .then((response) => {

    let notifications = []

    response.data.forEach(noti => {
      noti.data = JSON.parse(noti.data.replace(/'/g, '"'))
      if(noti.data){
        if (noti.data.type == "sinister")
          notifications.push(notificationTransformer.notificationSinister.fetch(noti))
        else if (noti.data.type == "sinisters")
          notifications.push(notificationTransformer.notificationSinisters.fetch(noti))
        else if (noti.data.type == "custom")
          notifications.push(notificationTransformer.customNotification.fetch(noti))
          else
        notifications.push(notificationTransformer.notification.fetch(noti))
      }
      else
        notifications.push(notificationTransformer.notification.fetch(noti))
    
    });
      
    
    success(notifications)
  })
}


// WEBPACK FOOTER //
// ./src/services/notification/getNotifications.js